import React, { useState } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import { Form, Input, Select, Upload } from "antd";
import Button from "../../atoms/Button";
import UploadIcon from "../../svgs/upload.svg";
import { ReactComponent as DownIcon } from "../../svgs/dropdown_icon.svg";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import {
  FileAddOutlined,
  DeleteOutlined,
  LoadingOutlined
} from "@ant-design/icons";
import { uploadDocument } from "../../../utils/API/uploadDocuments";
import { addBankAccount } from "../../../utils/API/addBankAccount";
import { useDispatch } from "react-redux";
import AcceptPopUp from "../../molecules/AcceptPopUp";
const inputClass = "border-0 border-b-2 rounded-none";

const allowedFileTypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf"
];

const AddBankAccount = ({ open, onSubmit, onCancel, setAccountDetails }) => {
  const dispatch = useDispatch();
  const [document, setDocument] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [form] = Form.useForm();

  const [ifscError, setIfscError] = useState(false);

  const handleIFSCChange = (e) => {
    let value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    form.setFieldsValue({ IFSC_code: value }); // Updates the input field

    // Show error if length is less than 11, hide it when it reaches 11
    if (value.length < 11) {
      setIfscError(true);
    } else {
      setIfscError(false);
    }
  };

  const onUpload = async ({ file, onSuccess, onError }) => {
    if (document.length === 1) {
      toast.error("Maximum 1 file can be uploaded");
      return;
    }

    const isAllowedType = allowedFileTypes.includes(file.type);
    if (!isAllowedType) {
      const fileExtensionsString = allowedFileTypes
        .map((fileType) => {
          const parts = fileType.split("/");
          return parts[1];
        })
        .join(", ");
      toast.error(`You can only upload ${fileExtensionsString} files!`);
      return;
    }

    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      toast.error("File must be smaller than 2MB!");
      return;
    }

    try {
      setLoading(true);
      const response = await uploadDocument(
        file,
        "bank_account_proof",
        document.length + 1,
        1,
        dispatch
      );
      onSuccess();
      setDocument([{ name: file.name, url: response.data, status: "done" }]);
      setLoading(false);
    } catch (error) {
      onError();
      setLoading(false);
      toast.error(error.message);
    }
  };

  const submitHandler = async (values) => {
    if (document.length === 0) {
      toast.error("Please upload bank proof");
      return;
    } else {
      const bank_info = { bank_account_proof: document[0].url, ...values };
      try {
        setSubmitLoading(true);
        const data = await addBankAccount(bank_info, dispatch);
        setPopupVisible(true);
        form.resetFields();
        onSubmit();
        setDocument([]);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setSubmitLoading(false);
      }
    }
  };

  const onClose = () => {
    setIfscError(false);
    form.resetFields();
    setDocument([]);
    onCancel();
  };

  const handlePopupOk = () => {
    setPopupVisible(false);
  };

  const handlePopupCancel = () => {
    setPopupVisible(false);
  };

  return (
    <>
      <DiaglogBox width={625} open={open} onCancel={onClose} closeIcon={false}>
        <div className="py-3 kyc_form max-h-96 overflow-y-scroll no-scrollbar">
          <h2 className="pl-6 text-2xl font-bold pb-3">Add Bank Account</h2>
          <hr className="border-1 border-[#BFBFBF] mx-2" />
          <Form className="pt-3" onFinish={submitHandler} form={form}>
            <div className="px-6 flex gap-x-8">
              <div className="w-1/2">
                <Form.Item
                  label="Bank Name"
                  className="font-normal m-0"
                  name="bank_name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter bank name"
                    }
                  ]}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input className={inputClass} />
                </Form.Item>
              </div>

              <div className="w-1/2">
                <Form.Item
                  label="Account Owner Name"
                  className="font-normal m-0"
                  name="account_owner_name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter account owner name"
                    }
                  ]}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input className={inputClass} />
                </Form.Item>
              </div>
            </div>
            <hr className="border-1 border-[#BFBFBF] mx-2 mt-3" />

            <div className="px-6 flex gap-x-8 pt-3">
              <Form.Item
                label="Bank Location"
                className="font-normal m-0 w-1/2"
                name="bank_address"
                rules={[
                  {
                    required: true,
                    message: "Please enter bank location"
                  }
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input
                  className={inputClass}
                  placeholder="Complete Bank Location"
                />
              </Form.Item>

              <Form.Item
                label="Account Type"
                className="font-normal w-1/2 m-0"
                name="account_type"
                initialValue={"current"}
                rules={[
                  {
                    required: true,
                    message: "Please select account type"
                  }
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Select
                  suffixIcon={
                    <DownIcon className="w-[11px] h-[5px] text-[#808080]" />
                  }
                  className="primary_variant"
                  options={[
                    { value: "saving", label: "Saving" },
                    { value: "current", label: "Current" }
                  ]}
                />
              </Form.Item>
            </div>

            <hr className="border-1 border-[#BFBFBF] mx-2 mt-3" />

            <div className="px-6 flex gap-x-8 pt-3">
              <div className="w-1/2">
                <Form.Item
                  label="Account No."
                  className="font-normal m-0"
                  name="account_no"
                  rules={[
                    {
                      required: true,
                      message: "Please enter account number"
                    },
                    {
                      pattern: /^[0-9]*$/,
                      message: "Please enter a valid contact number"
                    }
                  ]}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input className={inputClass} type="number" />
                </Form.Item>
              </div>

              <div className="w-1/2">
                <Form.Item
                  label="IFSC Code"
                  className="font-normal m-0"
                  name="IFSC_code"
                  validateStatus={ifscError ? "error" : "success"} // Show error dynamically
                  help={ifscError ? "IFSC Code must be exactly 11 characters" : ""}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    className={inputClass}
                    maxLength={11}
                    onChange={handleIFSCChange} // Converts input to uppercase dynamically
                    />
                </Form.Item>
              </div>
            </div>

            <hr className="border-1 border-[#BFBFBF] mx-2 mt-3" />

            <div className="px-6 flex gap-x-8 pt-3">
              <Form.Item
                label="Swift Code"
                className="font-normal m-0 w-1/2"
                name="swift_code"
                rules={[
                  {
                    required: true,
                    message: "Please enter swift code"
                  }
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input className={inputClass} />
              </Form.Item>

              <Form.Item
                label="MICR Code"
                className="font-normal m-0 w-1/2"
                name="MICR_code"
                rules={[
                  {
                    required: true,
                    message: "Please enter swift code"
                  }
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input className={inputClass} />
              </Form.Item>
            </div>

            <div className="w-full px-6 pt-3">
              <Form.Item label="Bank Account Proof">
                <Upload
                  maxCount={1}
                  showUploadList={false}
                  customRequest={onUpload}
                >
                  <Button
                    varient={"primary"}
                    color={"blue"}
                    className={
                      "px-2 py-1 rounded-[5px] text-xs text-white font-medium flex justify-center gap-x-1 items-center"
                    }
                  >
                    <img src={UploadIcon} alt="upload icon" className="w-3" />
                    Upload
                    {loading && <LoadingOutlined className="ml-2" />}
                  </Button>
                </Upload>
              </Form.Item>

              {document.length > 0 && (
                <div className="mb-4 border p-2 rounded-lg">
                  {document.map(({ name: fileName, url }, index) => (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.2 }}
                      className="group hover:bg-gray-100 px-2 py-1 flex justify-between items-center rounded-md"
                      key={`${"goverment_issued_id"}_${index}`}
                    >
                      <span>
                        <FileAddOutlined className="mr-2" />
                        <Link
                          to={url}
                          target="_blank"
                          className="hover:text-blue-800"
                        >
                          {" "}
                          {fileName}
                        </Link>
                      </span>
                      <DeleteOutlined
                        className="hidden group-hover:block cursor-pointer hover:text-blue-800"
                        onClick={() => {
                          setDocument([]);
                        }}
                      />
                    </motion.div>
                  ))}
                </div>
              )}
            </div>

            <div className="flex px-6 mt-4 gap-x-6">
              <Button
                disabled={submitLoading}
                type="submit"
                varient="primary"
                color="blue"
                className="w-1/2 text-sm font-bold text-white h-10"
              >
                {submitLoading ? <LoadingOutlined /> : "Submit"}
              </Button>
              <Button
                varient="primary"
                className="w-1/2  text-sm font-bold  text-blue-800  bg-[#4361EE26]  "
                onClick={onClose}
              >
                Cancel
              </Button>
            </div>
          </Form>
        </div>
      </DiaglogBox>
      <AcceptPopUp
        open={isPopupVisible}
        onCancel={handlePopupCancel}
        onOk={handlePopupOk}
        title="Account requested successfully"
        statusType=" We Will Revert back to you once Admin verifies your Details"
        okButtonText="OK"
        isRequiredColor="green"
        isRequiredCancelButton={false}
        width={600}
        isRequiredTitle={true}
        isRequiredStatus={true}
      />
    </>
  );
};

export default AddBankAccount;
